import { OptionalUnits } from 'utils/productMaps'
import { CORE_UNITS_LABEL, BULLYING_UNITS_LABEL } from './constants'

function isCoreUnit(unit) {
  return (
    OptionalUnits.BullyingHarassmentUnit.courseNodeIds.indexOf(
      unit.contentfulID,
    ) === -1
  )
}

function sumLessons(acc, unit) {
  return acc + unit.completeLessons
}

function getLessonsCount(rawData, lmsClass) {
  const coreLessonsAmount = rawData.tabSummaries.reduce((acc, unit) => {
    if (unit.route.includes(OptionalUnits.BullyingHarassmentUnit.slug)) {
      return acc
    }
    return acc + unit.lessonCount
  }, 0)

  const bullyingLessonsAmount = rawData.tabSummaries.reduce((acc, unit) => {
    if (unit.route.includes(OptionalUnits.BullyingHarassmentUnit.slug)) {
      return acc + unit.lessonCount
    }
    return acc
  }, 0)

  const hasBullyingLessons = bullyingLessonsAmount > 0
  const lessonsAmounts = [
    {
      totalAmount: coreLessonsAmount,
      totalComplete:
        lmsClass?.units.filter(isCoreUnit).reduce(sumLessons, 0) ?? 0,
      categoryLabel: hasBullyingLessons ? CORE_UNITS_LABEL : undefined,
    },
  ]

  if (hasBullyingLessons) {
    lessonsAmounts.push({
      totalAmount: bullyingLessonsAmount,
      totalComplete:
        lmsClass?.units.filter(u => !isCoreUnit(u)).reduce(sumLessons, 0) ?? 0,
      categoryLabel: BULLYING_UNITS_LABEL,
    })
  }

  return lessonsAmounts
}

export function getData(rawUnit, lmsClass) {
  const { courseContent } = rawUnit ?? {}
  const lessonsAmounts = getLessonsCount(courseContent, lmsClass)
  const scopeAndSequenceData = (courseContent?.coursePdf ?? []).map(
    coursePdf => ({
      linkLabel: coursePdf?.displayTitle ?? '',
      linkHref: coursePdf?.file?.url ?? '',
    }),
  )
  return { lessonsAmounts, scopeAndSequenceData }
}

export function extractUnitSlugsFromTabSummaries(tabSummaries) {
  return (
    tabSummaries?.map(tabSummary => {
      // the full pathname links to the preview routes
      // but we only need the last slug in the pathname, so extract that:
      const fullPathname = tabSummary.route
      const lastSlashIndex = fullPathname.lastIndexOf('/')
      return fullPathname.slice(lastSlashIndex + 1)
    }) ?? []
  )
}

// LEARN-20166 probably related to Fix back button issue with grade-x/unit-x where it will just go back to the grade path. Need to check on later
export function getCurrentUnit(ourClass, unitSlugs) {
  const index = ourClass.units?.findIndex(u => !u.is_done)
  const unitIndex = index >= 0 ? index + 1 : ourClass.units?.length
  if (!!unitSlugs && !!unitSlugs.length) {
    return unitSlugs[unitIndex - 1]
  }
  // NOTE: keeping this legacy behavior as a fallback, but ideally unitSlugs will always be populated:
  if (unitIndex === 5) {
    return 'recognizing-bullying-and-harassment'
  }
  return `unit-${unitIndex}`
}

export function getClassId(location) {
  const queryParams = new URLSearchParams(location?.search || '')
  const classId = queryParams.get('class')

  return classId
}

export function getClass(classes, classId) {
  return classes.find(c => c.instance === classId)
}
